/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { AxiosRequestConfig } from "axios";

export type RequestInterceptor = (
    requestConfig: AxiosRequestConfig
) => AxiosRequestConfig;

export const getRequestInterceptorForWorkspace = (
    workspaceId: string | null
): RequestInterceptor => {
    const requestInterceptor: RequestInterceptor = (requestConfig) => {
        // If workspaceId is available, attach it to the request
        if (workspaceId) {
            requestConfig.headers = {
                ...requestConfig.headers,
                Workspace: workspaceId,
            };
        }

        return requestConfig;
    };

    return requestInterceptor;
};
